import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsModalComponent } from './terms-modal/terms-modal.component';
import { SignUpComponent } from './sign-up.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule
  ],
  declarations: [
    SignUpComponent,
    TermsModalComponent,
  ],
  entryComponents: [TermsModalComponent]
})
export class SignUpModule { }



// WEBPACK FOOTER //
// ./src/app/components/sign-up/sign-up.module.ts